//static
export const LOCAL_STORAGE_SALT_KEY = "sevbaertg^&*%CDghuaft&%"

// dev
// export const MODE = "DEV";
// export const API = "https://dev.fun11.in:9010";
// export const SOCKET_BASE_URL = 'https://dev.fun11.in:9015';
// export const SALT_KEY = "dfgdljhkj_dev";
// export const APP_ID = "sfjgcfhgvh_dev";
// export const O_AUTH_CLIENT_ID = "242714598926-6o59sqdm6g8pnhr41r93223p2mb27elf.apps.googleusercontent.com"
// export const PAGES_PREVIEW = 'http://192.168.1.43:3000/';
// export const CARDS_PREVIEW = 'http://192.168.1.43:4000/';
// export const CHAT_DOMAIN = "http://192.168.1.43:3000/live-chat?domain=chat"
// export const CHAT_DOMAIN_PROFILE = "http://192.168.1.43:3000/settings?domain=chat"

//prod
export const MODE = "PROD";
export const API = "https://client-api.advy.me";
export const SOCKET_BASE_URL = 'https://client-api.advy.me:3004';
export const APP_ID = "skjdhfssudhfsdf9w40934t_prod";
export const SALT_KEY = "fdkjhg7845thn78gh3n875g_prod";
export const O_AUTH_CLIENT_ID = "242714598926-6o59sqdm6g8pnhr41r93223p2mb27elf.apps.googleusercontent.com"
export const PAGES_PREVIEW = 'https://page.advy.me/';
export const CARDS_PREVIEW = 'https://card.advy.me/';
export const CHAT_DOMAIN = "https://chat.advy.me/live-chat"
export const CHAT_DOMAIN_PROFILE = "https://chat.advy.me/settings"